module.exports = __webpack_public_path__ + "media/frontend/assets/icons/icon-move-history-630f6901bd56ec2c0b3c6f694a70d782.png";